import { TypographyProps } from '@mui/joy/Typography';
import clsx from 'clsx';

const textLevelStyles: Record<
  NonNullable<TypographyProps['level']>,
  string[]
> = {
  inherit: ['text-inherit'],
  h1: ['text-4xl/6'],
  h2: ['text-3xl/6'],
  h3: ['text-2xl/6'],
  h4: ['text-xl/6'],
  'title-sm': ['text-lg/6'],
  'title-md': ['text-base/6'],
  'title-lg': ['text-lg/6'],
  'body-xs': ['text-xs/6'],
  'body-sm': ['text-sm/6'],
  'body-md': ['text-base/6'],
  'body-lg': ['text-lg/6'],
};

export function Text({
  className,
  level = 'inherit',
  ...props
}: React.ComponentPropsWithoutRef<'span'> & {
  level?: TypographyProps['level'];
}) {
  return (
    <p
      {...props}
      data-slot='text'
      className={clsx(className, textLevelStyles[level])}
    />
  );
}
